const unitPriceElement = document.getElementById("unit-price-patch");
const amountInputElement = document.querySelector("#popover-variant-picker-template--17933044220169__main-1657033064548-1 > x-listbox > input[type=hidden]");

let transcyMoneySpans;


if (amountInputElement && unitPriceElement) amountInputElement.addEventListener("change", ()=> {
  
  // get all spans inside price
  transcyMoneySpans = unitPriceElement.querySelectorAll(".transcy-money")
  
  
  // remove the previous span
  if (transcyMoneySpans[0]) transcyMoneySpans[0].remove()
  unitPriceElement.innerHTML += ")"

})